import { memo, type ReactNode } from 'react';
import * as Tooltip from '~/components/ui/Tooltip';
import { GlobeWithShield } from '~/components/ui/icons/GlobeWithShield';
import { type DomainEntry } from '~/lib/stores/domains';

export const StatusIcon = memo(({ status }: { status: DomainEntry['status'] }) => {
  switch (status) {
    case 'not-configured': {
      return <span className="i-heroicons:exclamation-triangle text-bolt-ds-icon-secondary size-6 mt-0.5" />;
    }
    case 'complete': {
      return (
        <SimpleTooltip title="A secure HTTPS connection is active. Your domain is configured with a valid SSL certificate.">
          <GlobeWithShield className="size-6 mt-0.5" shieldClassName="fill-green-500" />
        </SimpleTooltip>
      );
    }
    case 'ssl-pending':
    case 'ssl-error': {
      return (
        <SimpleTooltip title="Your domain's DNS settings are configured but you domain does not have a valid SSL certificate.">
          <GlobeWithShield className="size-6 mt-0.5" shieldClassName="fill-orange-500" />
        </SimpleTooltip>
      );
    }
    case 'pending': {
      return (
        <SimpleTooltip title="The DNS records are being updated. This can take up to 24 hours.">
          <span className="i-heroicons:clock text-bolt-ds-icon-secondary size-6 mt-0.5" />
        </SimpleTooltip>
      );
    }
    default: {
      return <span className="i-svg-spinners:90-ring-with-bg size-6 inline-block" />;
    }
  }
});

const SimpleTooltip = ({ children, title }: { children: ReactNode; title: string }) => {
  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div className="flex">{children}</div>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side="bottom" align="center" sideOffset={6} maxWidth={240} truncate={false}>
            {title}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
